// Glycol / system-volume calculator constants. Water content per metre by
// nominal diameter (litres/m, from inner Ø ≈ DN), and propylene-glycol
// concentration for a frost-protection target. Editable approximations.

export type VolumePerM = { dn: number; litresPerM: number };

export const LITRES_PER_M: VolumePerM[] = [
  { dn: 20, litresPerM: 0.31 },
  { dn: 25, litresPerM: 0.49 },
  { dn: 32, litresPerM: 0.8 },
  { dn: 40, litresPerM: 1.26 },
  { dn: 50, litresPerM: 1.96 },
  { dn: 63, litresPerM: 3.12 },
  { dn: 75, litresPerM: 4.42 },
  { dn: 90, litresPerM: 6.36 },
];

export type FrostGlycol = { frostC: number; glycolPct: number };

// Approx propylene-glycol volume fraction for a frost-protection temperature.
export const FROST_GLYCOL: FrostGlycol[] = [
  { frostC: -10, glycolPct: 0.25 },
  { frostC: -15, glycolPct: 0.33 },
  { frostC: -20, glycolPct: 0.38 },
  { frostC: -25, glycolPct: 0.45 },
  { frostC: -30, glycolPct: 0.5 },
];

export function litresPerMFor(dn: number): number {
  let best = LITRES_PER_M[0]!;
  for (const r of LITRES_PER_M) if (Math.abs(r.dn - dn) < Math.abs(best.dn - dn)) best = r;
  return best.litresPerM;
}

export function glycolPctFor(frostC: number): number {
  let best = FROST_GLYCOL[0]!;
  for (const r of FROST_GLYCOL) if (Math.abs(r.frostC - frostC) < Math.abs(best.frostC - frostC)) best = r;
  return best.glycolPct;
}
